import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';
import { Stat } from '../../../../../CommonComponents/OPL/Stat/Stat';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../CommonUtils/formatNumber';
import { SummarySectionDTO } from '../../../../api/useBalanceSheetQuery';

interface Props {
  data: SummarySectionDTO;
  showDescription?: boolean;
}

export const Stats = ({ data, showDescription }: Props) => {
  const { netWorth, outOfEstateAssets, outOfEstateAssetsValue, total } = data;

  if (outOfEstateAssets === null) {
    return (
      <Card p="24" flex="1">
        <Box
          display="flex"
          flexDirection="column"
          css={({ theme }) => ({ gap: theme.space['16'] })}
        >
          <Stat label="Net Worth" value={formatCurrency(netWorth)} />

          {showDescription && (
            <Text color="neutral.600">
              Your net worth summary shows your total assets minus liabilities, giving you a
              complete picture of your financial position.
            </Text>
          )}
        </Box>
      </Card>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      css={({ theme }) => ({
        gap: theme.space['16'],
      })}
    >
      <Card p="24" flex="1">
        <Stat label="In-Estate Net Worth" value={formatCurrency(netWorth)} />
      </Card>

      <Card p="24" flex="1">
        <Stat label="Out-of-Estate Net Worth" value={formatCurrency(outOfEstateAssetsValue ?? 0)} />
      </Card>

      <Card p="24" flex="1">
        <Stat label="Total Family Resources" value={formatCurrency(total ?? 0)} />
      </Card>
    </Box>
  );
};
